export class TextChannel {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly type: 'whatsapp' | 'sms',
    readonly phoneNumber: string,
  ) {}
}
